import { render, staticRenderFns } from "./ChangeTimeDurationDropdown.vue?vue&type=template&id=dcba1186&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports